export const pluralize = (i, variants) => {
  let variant = 2;
  if (i % 10 === 1 && i % 100 !== 11) {
    variant = 0;
  }

  if (i % 10 >= 2 && i % 10 <= 4 && (i % 100 < 10 || i % 100 >= 20)) {
    variant = 1;
  }

  return variants[variant];
};
